
    <div class="ctl-search-area">
      <div class="searh-input-area">
        <span>Genel Arama :</span>
        <dx-text-box
          #searchBox
          [(value)]="searchValue"
          (onInput)="onKeyInput($event)"
          placeholder="Kod, Ad Soyad, TC Kimlik, Vergi No, Ünvan ..."
          [showClearButton]="true"
          mode="search"
        >
        </dx-text-box>
      </div>
        <div class="content" *ngIf="gridControlsList$ | async as gridControlsListItem">
            <div class="first-table-container">
              <dk-dx-data-table2
              class="px-7"
              [dataSource]="data"
              [columnList]="columns"
              [columnTransactions]="false"
              height="100%"
              [gridCtlList]="gridControlsListItem"
              [filterValue]="filterValue?filterValue:null"
              (focusedRowChanged)="focusChanged($event)"
              [dontSelectDataSource]="true"
              (customSearch)="customSearch($event)"
              (onContentReady)="onContentReady($event)"
              [focusSearchBar]="true"
                [isGroupingYn]="false"
                (keyDown)="onKeyDown($event)"
                (rowDblClick)="dblClickRow($event)"
              >
            </dk-dx-data-table2>
            </div>
          </div>
        <div class="search-btn-area">
            <div>
                <dx-button
                    icon="check"
                    stylingMode="contained"
                    text="Seç"
                    type="success"
                    [width]="150"
                    (onClick)="chooseBtnClick()">
                </dx-button>
            </div>
            <div class="search-right-btn">
                <dx-button
                    icon="close"
                    stylingMode="contained"
                    text="İptal"
                    type="danger"
                    [width]="150"
                    (onClick)="cancelBtnClick()">
                </dx-button>
            </div>
        </div>
    </div>
